<template>
  <section>
    <header>
      <div>
        <p>Etapa {{ step.index + 1 }} de {{ totalSteps }}</p>
        <h4>Planos de Pagamento</h4>
        <p>Clique em <b>MATRICULE-SE JÁ para selecionar</b> como você prefere<br/>pagar sua <b class="color-primary">Plataforma Educacional Rede Decisão</b></p>
        <!-- <div class="intro">
          <p><b>Ouvimos vocês e simplificamos a visualização dos planos de pagamento e produtos no aplicativo.</b></p>
          <p>A partir deste ano, vocês terão à disposição dois planos de pagamento para a compra unificada da nossa Plataforma Educacional. Ela inclui serviços escolares e materiais didáticos de alta qualidade, além de projetos exclusivos e recursos digitais interativos, para ajudar seu filho a atingir seu pleno potencial e realizar seus sonhos.</p>
          <p>Lembramos que o valor do desconto aplicado na sua mensalidade em 2024 foi convertido em um desconto sobre o pacote completo em 2025. Mas não se preocupe, seu desconto continua o mesmo.</p>
        </div> -->
        <div class="desconto-banner" @click.prevent="toggleVideo()">
          <div class="bannerContent">
            <div>
              <h1>Entenda como funciona seu desconto</h1>
              <p>Assista o vídeo explicativo para saber mais</p>
            </div>
            <div>
              <div class="play">
                <svg id="play" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 96 96.52">
                  <g id="Group_229">
                    <g id="Ellipse_17">
                      <circle cx="48" fill="none" cy="48.26" r="48"/>
                      <path class="st1" fill="#ED1C24" d="M48,96.26C21.53,96.26,0,74.73,0,48.26S21.53.26,48,.26s48,21.53,48,48-21.53,48-48,48ZM48,10.26c-20.95,0-38,17.05-38,38s17.05,38,38,38,38-17.05,38-38S68.95,10.26,48,10.26Z"/>
                      <a href="#" @click.prevent="videoOn = false" class="btn btn-primary btn-squared">Fechar</a>
                    </g>
                    <g id="Polygon_2">
                      <path class="st1" fill="#ED1C24" d="M69.5,48.76l-33,19V29.76l33,19Z"/>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="bannerBody">
            <img :src="require('@/assets/img/banner_plano_pagamento.png')"/>
            <img class="mobile" :src="require('@/assets/img/banner_plano_pagamento_mobile.png')"/>
          </div>
        </div>
        <h4 v-if="finalDate" class="finalDate">Ofertas disponíveis até <span>{{ formatDate(finalDate) }}</span></h4>
      </div>
      <div v-if="!auto">
        <a href="#" @click.prevent="toggleDescontos()" class="btn btn-primary">
          <span>Descontos</span>&nbsp;
          <fa :icon="['fas','badge-percent']"></fa>
        </a>
      </div>
    </header>
    <section>
      <desconto-matricula :active="descontoActive" @close="descontoActive = false" @save="refreshPlanos" :idMatricula="idMatricula"></desconto-matricula>
      <plano-pagamento ref="plano" @ready="setReady()" :auto="auto" :action="action" :idMatricula="idMatricula" @finalDate="finalDate = $event"></plano-pagamento>
    </section>
    <modal ref="modal" :wrapped="auto">
      <iframe 
        :width="videoConfigs.usable.w" 
        :height="videoConfigs.usable.h" 
        :src="video" 
        title="Vamos Construir Juntos em 2025!" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; modestbranding;" 
        referrerpolicy="strict-origin-when-cross-origin" 
        allowfullscreen
        v-if="videoOn"
      ></iframe>
      <a href="#" @click.prevent="closeVideo()" class="btn btn-primary">Fechar</a>
    </modal>
  </section>
</template>

<script>
import PlanoPagamento from '@/components/matriculas/form/PlanoPagamento'
import DescontoMatricula from '@/components/matriculas/form/DescontoMatricula'
import Modal from "@/components/utilities/Modal"
import { formatDate } from '@/services/utils.service.js'

export default {
  components: {
    PlanoPagamento, DescontoMatricula, Modal
  },
  props: {
    ready: {
      type: Boolean,
      default: false
    },
    auto: {
      type: Boolean,
      default: false
    },
    action: {
      type: String
    },
    idMatricula: {
      type: [Number, String]
    },    
    step: {
      type: Object
    },
    totalSteps: {
      type: Number
    }
  },
  data () {
    return {
      descontoActive: false,
      finalDate: null,
      videoConfigs: {
        raw: {
          w: 315,
          h: 560
        },
        usable: {
          w: 315,
          h: 560
        }
      },
      video: 'https://www.youtube-nocookie.com/embed/5uJ30N99-2E?controls=0',
      videoOn: false
    }
  },
  mounted () {
    
  },
  methods: {
    validate () {
      return this.$refs.plano.validate()
    },
    toggleDescontos () {
      this.descontoActive = !this.descontoActive
    },
    refreshPlanos () {
      this.$refs.plano.getPlanosPagamento()
    },
    setReady () {
      this.$emit('ready')
    },
    formatDate ( date ) {
      return formatDate(date)
    },
    toggleVideo () {
      const options = {
        size: "mid", //small, mid, normal, large, full
        backdrop: true,
        backdropColor: "transparent",  //se o backdrop for false, não precisa
        backdropClose: true,
				// padding: 0,
        onClose: this.videoOn = false
      }

			this.videoOn = true
      this.$refs.modal.open(options)
    },
    closeVideo () {
      this.videoOn = false
      this.$refs.modal.close()
    }
  }
}
</script>

<style lang="scss" scoped>
  header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .finalDate {
      display: inline-block;
      padding: $mg_mini;
      border-radius: $border-radius;
      background-color: $color-secondary;
      margin: $mg 0 $hmg_mid 0;
      border: $border-component;

      span {
        color: $color-primary;
      }
    }

    .intro {
      padding: $hmg_mini 0;
      border: $border-component;
      border-radius: $border-radius;
      margin: $mg_mini 0 0 -10px;
      max-width: 70%;
      background-color: $color-secondary;

      p {
        font-size: $font-size-larger;
        padding: $hmg_mini $mg_mini; 
        margin: 0;

        &:last-child {
          border-top: $border-component;
          padding: $mg_mini $mg_mini $hmg_mini;
          margin-top: $hmg_mini !important;
          font-weight: bold
        }
      }
      @media screen and ( max-width: 1024px ) {
        max-width: 100%;
      }
    }
  }

  .desconto-banner {
    margin-top: $mg;
    position: relative;
    cursor: pointer;

    .play {
      width: 96px; height: 96px;
      transform-origin: center;
      @extend %transition_4e;

      @media screen and ( max-width: 689px ) {
        width: 66px; height: 66px;
        margin-left: $hmg
      }
    }
    
    .bannerContent {
      position: absolute; bottom: 0; left: 0;
      z-index: 10;
      width: 100%; height: 180px; align-items: center;
      display: flex; justify-content: space-between;

      @media screen and ( max-width: 689px ) {
        flex-direction: column-reverse;
        align-items: flex-start;
      }

      >div {
        &:first-child {
          padding: $mg_mid;
          max-width: 55%;
          color: $color-secondary;

          h1 {
            margin-bottom: $hmg_mid;
          }
          p {
            margin: 0;
          }

          @media screen and ( max-width: 689px ) {
            max-width: 100%;

            h1 {
              font-size: 2em;
            }
            p {
              margin: 0;
            }
          }
        }

        &:last-child {
          padding-right: $mg_mid
        }
      }
    }
    .bannerBody {
      width: 750px; height: 180px;
      border-radius: $border-radius;
      background-color: $color-secondary;
      position: relative;
      @extend %shadow-high;

      @media screen and ( max-width: 689px ) {
        width: 300px; height: 270px;
      }
      
      > img {
        display: block; width: 100%; height: auto;
        position: absolute; bottom: 0;

        &.mobile {
          display: none;
        }
      }

      @media screen and ( max-width: 689px ) {
        >img {
          display: none;
          &.mobile {
            display: block;
          }
        }
      }
    }

    &:hover {
      .play {
        transform: scale(1.1);
      }
    }

    @media screen and (max-width: 689px) {
      
    }
  }
</style>



